export const SCHEDULE_TYPE = {
  NOW: "now",
  NEXT_DAY: "next_day",
  NEXT_WEEK: "next_week",
  OTHER_DATE: "other_date"
};
